import React from "react";
import { Link } from "react-router-dom";
const Booklist = () => {
  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/home"> Home</Link>{" "}
          </li>
          <li>Booklist </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Booklist</h1>
            </div>
          </div>
          <div className="row justify-content-left">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card shadow p-3 text-center">
                <h5 className="mb-3">General Book List</h5>
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSJ/public/pdf/BookList.xlsx"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn custom-btn"
                >
                  View PDF
                </a>
              </div>
            </div>
            {/* Box 1 */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card shadow p-3 text-center">
                <h5 className="mb-3">KG Book List</h5>
                <a
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSJ/public/pdf/BookList-kg.xlsx"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn custom-btn"
                >
                  View PDF
                </a>
              </div>
            </div>

            {/* Box 2 */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Booklist;
